import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-chip-filter',
  templateUrl: './chip-filter.component.html',
  styleUrls: ['./chip-filter.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipFilterComponent {
  @Input() chips: any[] = [];
  @Input() selected: string | number | null = null; 
  @Output() selectedChip = new EventEmitter<any>();

  isSelected(chip: any): boolean {
    return String(chip?.id ?? '') === String(this.selected ?? '');
  }

  onChipSelected(chip: any, event: Event) {
    const { detail }: CustomEvent<boolean> = event as CustomEvent<boolean>;
    if (!detail) return;
    if (this.isSelected(chip)) return;
    this.selected = chip.id;
    this.selectedChip.emit(chip);
  }
}